import React from "react";
import { View, Text, TouchableOpacity } from "react-native";
import {
  COLORS,
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";

interface Props {
  label: string;
  value?: string;
  onPress: () => void;
  icon: React.ReactNode;
}

const DateInputCard = ({ label, value, onPress, icon }: Props) => {
  return (
    <TouchableOpacity
      style={[
        COMMON_STYLES.justifyBetween,
        COMMON_STYLES.row,
        COMMON_STYLES["p3/4"],
        COMMON_STYLES["mb3/4"],
        COMMON_STYLES.b1,
        { borderColor: "#E2E8F0", borderRadius: 12 },
        value ? { backgroundColor: COLORS.neutral00 } : null,
      ]}
      onPress={onPress}
      activeOpacity={0.8}
    >
      <View style={[COMMON_STYLES["mb1/4"], { gap: 8 }]}>
        <Text
          style={[
            TEXT_STYLES.textPrimary100,
            TYPOGRAPHY.CAPTION1,
            VARIANTS_STYLES.MEDIUM,
          ]}
        >
          {label}
        </Text>
        <Text
          style={[
            TEXT_STYLES.textNeutral90,
            TYPOGRAPHY.TEXT2,
            !value && TEXT_STYLES.textNeutral70,
          ]}
        >
          {value || " Month - DD - YYYY"}
        </Text>
      </View>
      <View
        style={[
          COMMON_STYLES.row,
          COMMON_STYLES.justifyBetween,
          COMMON_STYLES.alignItemsCenter,
        ]}
      >
        {icon}
      </View>
    </TouchableOpacity>
  );
};

export default DateInputCard;
